import './Schools.css'
import { useEffect, useState, useRef } from 'react'
import { Button, CircularProgress, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box, InputAdornment, Typography, FormControlLabel, Switch } from '@mui/material'
import { QRCodeCanvas } from 'qrcode.react';
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import * as XLSX from 'xlsx';
import { Tooltip } from '@mui/material';
// Components
import StandardPageWrapper from '../../../components/StandardPageWrapper/StandardPageWrapper'
import StandardButton from '../../../components/StandardButton/StandardButton';
import StandardOutlinedTextfield from '../../../components/StandardOutlinedTextfield/StandardOutlinedTextfield'
import ReactCustomTable from '../../../components/ReactCustomTable/ReactCustomTable'
import StandardMuiDialogWrapper from '../../../components/StandardMuiDialogWrapper/StandardMuiDialogWrapper'
import DifferenceIcon from '@mui/icons-material/Difference';
// ICONs & SVGs
import { Delete, Edit, ArrowForward, Download, ContentCopy, Visibility, Refresh } from '@mui/icons-material'




function Schools() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [allSchoolData, setAllSchoolData] = useState([]);
  const [allSchoolDataLoading, setAllSchoolDataLoading] = useState(true);

  const [downloadAllLoading, setDownloadAllLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogBtnLoading, setDialogBtnLoading] = useState(false);
  const [addSchoolData, setAddSchoolData] = useState({
    name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: ''
    , final_count: '', is_ids: 1
  });
  // Delete
  const [deleteID, setDeleteID] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);
  // Edit
  const [editActive, setEditActive] = useState(false);
  const [editId, setEditId] = useState('');
  // Download
  const [downloadId, setDownloadId] = useState('');
  const [downloadLoading, setDownloadLoading] = useState(false);
  // Search
  const [searchInput, setSearchInput] = useState("");

  //Show QR
  const [qrOpen, setQrOpen] = useState(false);
  const [qrData, setQrData] = useState("");
  const qrRef = useRef(null);
  const [qrFileName, setQrFileName] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [refreshSchools, setRefreshSchools] = useState(0);

  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);


  //for sending to login field
  const [openCopyTextDialog, setOpenCopyTextDialog] = useState(false);
  const [copyText, setCopyText] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  // Delete confirmation dialog
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);




  useEffect(() => {
    fetchAllSchools();
  }, [refreshSchools, page, limit, searchInput])

  const fetchAllSchools = async () => {
    setAllSchoolDataLoading(true);
    await axios.get(`${process.env.REACT_APP_BASE_URL}/user/getallschool`, {
      params: { page, limit, search: searchInput }
    })
      .then(res => {
        if (res.data.success) {
          setAllSchoolData(res.data.data);
          setTotalCount(res.data.totalCount || 0);
        } else {
          enqueueSnackbar('Error Fetching Schools, Try Again !!!', { variant: 'error' })
        }
        setAllSchoolDataLoading(false);
      })
      .catch(err => {
        console.log(err);
        setAllSchoolDataLoading(false);
        return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
      })
  }

  const handleOpenTextDialog = () => {
    setCopyText("");
    setOpenCopyTextDialog(true);
  };

  const handleCloseTextDialog = (e) => {
    e?.stopPropagation();
    setOpenCopyTextDialog(false);
  };


  const handleSubmitCopyText = () => {
    onCopyLink1(selectedRow, copyText);
    setOpenCopyTextDialog(false);
  };



  const onExited = () => {
    setAddSchoolData({ name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: '', final_count: '' });
    setEditActive(false);
  }

  // Auto-generate school ID and password based on school name
  const generateSchoolCredentials = (schoolName) => {
    if (!schoolName || schoolName.trim() === '') {
      return { school_login_id: '', secret_code: '' };
    }

    const skipWords = ['of', 'the', 'and', 'or', 'for', 'in', 'on', 'at', 'to', 'a', 'an', 'is', 'as'];

    // Clean and split words
    const words = schoolName.trim()
      .split(/\s+/)
      .filter(word => word.length > 0)
      .map(word => word.replace(/[^a-zA-Z0-9]/g, '')) // Remove special characters
      .filter(word => word.length > 0);

    let schoolId = '';

    if (words.length === 1) {
      // Single word: Take first 5-6 characters (uppercase)
      const word = words[0];
      const prefix = word.substring(0, Math.min(6, word.length)).toUpperCase();
      const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
      schoolId = `${prefix}${randomNum}`;
    } else if (words.length === 2) {
      // Two words: Take 4 chars from first word + 3 chars from second word
      const firstPart = words[0].substring(0, Math.min(4, words[0].length)).toUpperCase();
      const secondPart = words[1].substring(0, Math.min(3, words[1].length)).toUpperCase();
      const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
      schoolId = `${firstPart}${secondPart}${randomNum}`;
    } else {
      // Multiple words: Use first letter (initial) of each significant word
      // Filter out common words like "of", "and", "the", etc.
      const significantWords = words.filter(word =>
        !skipWords.includes(word.toLowerCase())
      );

      // If we filtered out too many, use all words
      const wordsToUse = significantWords.length >= 2 ? significantWords : words;

      // Take first letter of each word
      const initials = wordsToUse.map(word =>
        word.charAt(0).toUpperCase()
      ).join('');

      const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
      schoolId = `${initials}${randomNum}`;
    }

    // Generate Password: Based on school name with special characters and numbers
    const specialChars = ['@', '#', '$', '%', '&', '*', '!'];
    const nameLower = schoolName.toLowerCase().replace(/\s/g, '').replace(/[^a-z0-9]/g, '');
    const nameLength = nameLower.length;
    const nameLengthStr = nameLength.toString();
    const randomSpecial = specialChars[Math.floor(Math.random() * specialChars.length)];
    const randomNum2 = Math.floor(Math.random() * 100).toString().padStart(2, '0');

    // Create password: first 4-5 chars of name + special char + numbers + last 2 chars
    const namePrefix = nameLower.substring(0, Math.min(5, nameLower.length));
    const nameSuffix = nameLower.substring(Math.max(0, nameLower.length - 2));
    const password = `${namePrefix}${randomSpecial}${nameLengthStr}${randomNum2}${nameSuffix}`;

    return { school_login_id: schoolId, secret_code: password };
  }

  // Handle school name change and auto-generate credentials
  const handleSchoolNameChange = (value) => {
    const updatedData = { ...addSchoolData, name: value };

    // Only auto-generate if we're in "Add" mode (not editing)
    // This allows the fields to be editable - user can modify the generated values
    if (!editActive && value.trim() !== '') {
      const generated = generateSchoolCredentials(value);
      updatedData.school_login_id = generated.school_login_id;
      updatedData.secret_code = generated.secret_code;
    }

    setAddSchoolData(updatedData);
  }

  // Regenerate/Scramble login ID while keeping it related to school name
  const regenerateLoginId = () => {
    if (!addSchoolData.name || addSchoolData.name.trim() === '') {
      enqueueSnackbar('Please enter school name first!', { variant: 'warning' });
      return;
    }

    // Generate a completely new ID based on school name
    // This will create a different ID each time by using a new random number
    const generated = generateSchoolCredentials(addSchoolData.name);

    setAddSchoolData({ ...addSchoolData, school_login_id: generated.school_login_id });
    enqueueSnackbar('Login ID regenerated!', { variant: 'info' });
  }

  const onDownloadAllClick = () => {
    if (allSchoolDataLoading) return;
    setDownloadAllLoading(true);
    if (allSchoolData?.length <= 0) return enqueueSnackbar('No Data Found', { variant: 'error' })
    // const excelHeaders = Object.keys(res.data.data?.[0])
    try {
      var fixedHeaders = [
      ];

      var dynamicHeaders = Object.keys(allSchoolData?.[0]).filter(
        (header) => !fixedHeaders.includes(header)
      );

      var allHeaders = fixedHeaders.concat(dynamicHeaders);

      var worksheet = XLSX.utils.json_to_sheet(allSchoolData, {
        header: allHeaders,
      });
      const wb = { Sheets: { 'ID SOLUTIONS Schools': worksheet }, SheetNames: ['ID SOLUTIONS Schools'] };
      XLSX.writeFile(wb, 'ID SOLUTIONS Institute List.xls');

      setDownloadAllLoading(false);
    }
    catch (err) {
      console.log(err);
      setDownloadLoading(false);
      return enqueueSnackbar('Something Went Wrong Downloading !!!', { variant: 'error' })
    }
  }

  const onAddSchool = async () => {
    // Exclude 'final_count' from the empty check
    const { final_count, ...rest } = addSchoolData || {};
    if (Object.values(rest)?.includes('')) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })
    setDialogBtnLoading(true);

    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/addschool`, addSchoolData)
      .then(res => {
        if (res.data.success) {
          // setAllSchoolData([...allSchoolData, res.data.result[0]])
          enqueueSnackbar('School Added Successfully !!!', { variant: 'success' })
          setOpenDialog(false);
          setDialogBtnLoading(false);
          fetchAllSchools();
        } else {
          // Check if error is "login id already"
          const errorMessage = res.data.message || res.data.result || '';
          const isLoginIdExists = errorMessage.toLowerCase().includes('login id already') ||
            errorMessage.toLowerCase().includes('login id') ||
            (res.data.result && typeof res.data.result === 'string' && res.data.result.toLowerCase().includes('login id already'));

          if (isLoginIdExists) {
            enqueueSnackbar('Login ID already exists! Please click refresh button to generate a new one.', { variant: 'error' })
            // Keep dialog open - don't close it
          } else {
            enqueueSnackbar(errorMessage || 'Error adding school!', { variant: 'error' })
            // Keep dialog open for other errors too, so user can fix and retry
          }
          setDialogBtnLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setDialogBtnLoading(false);
        // Check response data for login id error
        const errorResult = err.response?.data?.result || '';
        const errorMessage = err.response?.data?.message || '';
        if ((typeof errorResult === 'string' && errorResult.toLowerCase().includes('login id already')) ||
          (typeof errorMessage === 'string' && errorMessage.toLowerCase().includes('login id already'))) {
          enqueueSnackbar('Login ID already exists! Please click refresh button to generate a new one.', { variant: 'error' })
        } else {
          enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
        }
        // Keep dialog open on error
      })
  }

  const onDelete = (e, data) => {
    e.stopPropagation();

    if (!data?.schoolid) {
      return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' });
    }

    setDeleteTarget(data);
    setOpenDeleteDialog(true);
  };


  const confirmDeleteSchool = async () => {
    if (!deleteTarget?.schoolid) return;

    setDeleteID(deleteTarget.schoolid);
    setDeleteLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/deleteschool`,
        { schoolid: deleteTarget.schoolid }
      );

      if (res.data.success) {
        setAllSchoolData(prev =>
          prev.filter(s => s.schoolid !== deleteTarget.schoolid)
        );
        enqueueSnackbar('School Deleted Successfully !!!', { variant: 'success' });
      } else {
        enqueueSnackbar('Error Deleting School, Try Again !!!', { variant: 'error' });
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });
    } finally {
      setDeleteID('');
      setDeleteLoading(false);
      setOpenDeleteDialog(false);
      setDeleteTarget(null);
    }
  };

  const cancelDeleteSchool = () => {
    setOpenDeleteDialog(false);
    setDeleteTarget(null);
  };




  const onEdit = (e, data) => {
    e.stopPropagation();
    if (!data.schoolid) return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' })
    setEditId(data.schoolid);
    setOpenDialog(true);
    setEditActive(true);
    setAddSchoolData({
      name: data?.name, address: data?.address, school_login_id: data?.school_login_id, secret_code: data?.secret_code,
      contact_person: data?.contact_person, del_address: data?.del_address, con_mobile: data?.con_mobile, final_count: data?.final_count, is_ids: data?.is_ids
    })
  }

  const onSaveEdit = async () => {
    if (!editId) return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' })
    if (Object.values(addSchoolData)?.includes('')) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })

    setDialogBtnLoading(true);

    let body = { ...addSchoolData, schoolid: editId, is_ids: addSchoolData.is_ids ? 1 : 0 }
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateschool`, body)
      .then(res => {
        if (res.data.success) {
          const editDataIndex = allSchoolData.findIndex(i => i.schoolid == editId);
          if (editDataIndex === -1) return enqueueSnackbar('Error Updating School !!!', { variant: 'success' })

          let arr = [...allSchoolData]
          arr[editDataIndex] = body;
          setAllSchoolData(arr)
          enqueueSnackbar('School Updated Successfully !!!', { variant: 'success' })
          setRefreshSchools(prev => prev + 1);
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
        }
        setOpenDialog(false);
        setEditActive(false);
        setDialogBtnLoading(false);
        setEditId('');
        setAddSchoolData({ name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: '' });
      })
      .catch(err => {
        console.log(err);
        setDialogBtnLoading(false);
        return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
      })
  }

  const onDownloadClick = async (e, data) => {
    e.stopPropagation();
    if (downloadLoading) return;
    if (!data?.verified_count || data?.verified_count <= 0) return enqueueSnackbar('No ID Cards Mapped To This School !!!', { variant: 'error', preventDuplicate: false })
    if (!data?.schoolid) return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' })
    setDownloadId(data?.schoolid);
    setDownloadLoading(true);

    let body = { id: data?.schoolid }
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/schoolexportexcel`, body)
      .then(res => {
        if (res.data.success) {
          if (res.data.data?.length <= 0) return enqueueSnackbar('No Data Found', { variant: 'error' })

          // const excelHeaders = Object.keys(res.data.data?.[0])

          var fixedHeaders = [
            "first_name_student",
            "phone_no_student",
            "class_id_student",
            "school_id_student",
            "Photo",
            "class_id"
          ];

          var dynamicHeaders = Object.keys(res.data.data?.[0]).filter(
            (header) => !fixedHeaders.includes(header)
          );

          var allHeaders = fixedHeaders.concat(dynamicHeaders);

          var worksheet = XLSX.utils.json_to_sheet(res.data.data, {
            header: allHeaders,
          });
          const wb = { Sheets: { 'ID SOLUTIONS Schools': worksheet }, SheetNames: ['ID SOLUTIONS Schools'] };
          XLSX.writeFile(wb, 'ID SOLUTIONS.xls');
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
        }
        setDownloadLoading(false);
      })
      .catch(err => {
        console.log(err);
        setDownloadLoading(false);
        return enqueueSnackbar('Something Went Wrong Downloading !!!', { variant: 'error' })
      })
  }

  const showQr = (e, data) => {
    e.stopPropagation();
    const link = `https://gjaaipublication.com/login?con_mobile=${data.ids_phone_no}`;
    setSchoolName(data.name);
    setQrData(link);
    setQrFileName(`${data.name}`);
    setQrOpen(true);
  };

  const downloadQRCode = (e, data) => {
    if (!qrRef.current) return;

    const canvas = qrRef.current.querySelector('canvas');
    if (!canvas) return;

    const url = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = url;
    link.download = `${qrFileName.replace(/[^a-z0-9]/gi, " ")}`;
    link.click();
  };

  const copyQRCode = async () => {
    if (!qrRef.current) return;

    const canvas = qrRef.current.querySelector('canvas');
    if (!canvas) return;

    // Full instructions text
    const instructionsText = `Step-1:

Download ID Solutions app on Playstore

OR

Click this Link:
https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication

Step-2:

Scan This QR For Login`;

    try {
      // Copy image to clipboard
      canvas.toBlob(async (blob) => {
        try {
          if (navigator.clipboard && window.ClipboardItem) {
            // Create a ClipboardItem with both image and text formats
            // Applications can choose which format to paste
            const clipboardItem = new window.ClipboardItem({
              'image/png': blob,
              'text/plain': new Blob([instructionsText], { type: 'text/plain' })
            });
            await navigator.clipboard.write([clipboardItem]);

            enqueueSnackbar('Instructions and QR Code copied to clipboard!', { variant: 'success' });
          } else {
            // Fallback: copy text only
            await navigator.clipboard.writeText(instructionsText);
            enqueueSnackbar('Instructions copied to clipboard! (Image copy not supported in this browser)', { variant: 'info' });
          }
        } catch (err) {
          console.error('Failed to copy with ClipboardItem:', err);
          // Fallback: copy text only
          await navigator.clipboard.writeText(instructionsText);
          enqueueSnackbar('Instructions copied to clipboard!', { variant: 'success' });
        }
      });
    } catch (err) {
      console.error('Failed to copy:', err);
      enqueueSnackbar('Failed to copy QR Code', { variant: 'error' });
    }
  };


  const onCopyLink = (e, data) => {
    const link = `https://forms.gjaaipublication.com/?schoolId=${data.unique_key}&for=parent`;
    navigator.clipboard.writeText(link)
      .then(() => enqueueSnackbar('Link copied to clipboard!', { variant: 'success' }))
      .catch(err => enqueueSnackbar('Failed to copy link.', { variant: 'error' }));
  };
  const onCopyLink1 = (rowData, text) => {
    if (!rowData?.unique_key) {
      enqueueSnackbar('Invalid row data', { variant: 'error' });
      return;
    }
    const encodedText = encodeURIComponent(text);
    const link = `https://forms.gjaaipublication.com/?schoolId=${rowData.unique_key}&for=student&text=${encodedText}`;
    navigator.clipboard
      .writeText(link)
      .then(() =>
        enqueueSnackbar('Link copied to clipboard!', { variant: 'success' })
      )
      .catch(() =>
        enqueueSnackbar('Failed to copy link.', { variant: 'error' })
      );
  };


  const onNavigatetoClass = (e, data) => navigate(`/schools/${data.schoolid}`, { state: data })

  const tableActions = [
    {
      // icon:
      icon: (
        <Tooltip title="Copy Student Link">
          <ContentCopy sx={{ cursor: 'pointer', color: 'gray' }} />
        </Tooltip>
      ),
      onClick: (e, rowData) => {
        // 👇 event may or may not be a real event, so guard it
        if (e?.stopPropagation) e.stopPropagation();
        setSelectedRow(rowData);
        handleOpenTextDialog();
      }, btnType: 'copy'
    },
    {
      icon: (
        <Tooltip title="Copy Parent Link">
          <DifferenceIcon sx={{ cursor: 'pointer', color: 'black' }} />
        </Tooltip>
      ),
      onClick: onCopyLink,
      btnType: 'copy',
    },
    //  { icon: <ContentCopy sx={{ cursor: 'pointer', color: 'gray' }} />, onClick: onCopyLink, btnType: 'copy' },
    { icon: <Delete sx={{ cursor: 'pointer' }} color='error' />, onClick: onDelete, btnType: 'del' },
    { icon: <Edit sx={{ cursor: 'pointer', color: '#7978e9' }} />, onClick: onEdit },
    { icon: <Download sx={{ cursor: 'pointer', color: 'darkgreen' }} />, onClick: onDownloadClick, btnType: 'download' },
    { icon: <Visibility sx={{ cursor: 'pointer', color: 'blue' }} />, onClick: showQr },
    { icon: <ArrowForward sx={{ cursor: 'pointer' }} color='primary' />, onClick: onNavigatetoClass },
  ]

  const filterIdCards = (data) => {
    return data.filter((card) => {
      const searchString =
        `${card.schoolid} ${card.name} ${card.school_login_id} ${card.contact_person} ${card.address}`.toLowerCase();
      return searchString.includes(searchInput.toLowerCase());
    });
  };
  return (
    <StandardPageWrapper
      header="Schools"
      btns={
        <>
          <StandardButton
            variant="contained"
            onClick={onDownloadAllClick}
            loading={downloadAllLoading}
            style={{ background: "darkgreen !important", marginRight: "1rem" }}
            label="Download All"
          />
          <Button
            variant="contained"
            component="label"
            onClick={() => setOpenDialog(true)}
          >
            Add School
          </Button>
        </>
      }
    >
      <TextField
        sx={{ marginRight: "30px", marginLeft: "10px" }}
        variant="outlined"
        type="text"
        fullWidth
        placeholder="Search Schools..."
        value={searchInput}
        onChange={(e) => {
          setSearchInput(e.target.value);
          setPage(1);
        }}
      />
      <div id="schools">
        <ReactCustomTable
          data={allSchoolData}
          tableColumns={tableColumns}
          loading={allSchoolDataLoading}
          tableActions={tableActions}
          actionsColumnWidth={250}
          deleteID={deleteID}
          deleteLoading={deleteLoading}
          rowDataDeleteKey="schoolid"
          circularColor="#d32f2f"
          downloadId={downloadId}
          downloadLoading={downloadLoading}
          // Pagination props
          total={totalCount}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={(l) => { setLimit(l); setPage(1); }}
        />
      </div>

      <Dialog open={qrOpen} onClose={() => setQrOpen(false)}  >
        <DialogTitle>{`${schoolName}`}</DialogTitle>
        <DialogContent sx={{ padding: "10px" }}>
          {/* Step-1 */}
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#7978e9' }}>
            Step-1:
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Download ID Solutions app on Playstore
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, fontWeight: 'bold' }}>
            OR
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Click this Link:{' '}
            <a
              href="https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#7978e9', textDecoration: 'none' }}
            >
              https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication
            </a>
          </Typography>

          {/* Step-2 */}
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#7978e9' }}>
            Step-2:
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Scan This QR For Login
          </Typography>

          {/* QR Code Display */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div ref={qrRef}>
              {qrData ? (
                <QRCodeCanvas value={qrData} size={220} includeMargin={true} />
              ) : (
                <p>No QR Data</p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={downloadQRCode}
              startIcon={<Download />}
            >
              Download QR
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={copyQRCode}
              startIcon={<ContentCopy />}
            >
              Copy
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openCopyTextDialog}
        onClose={handleCloseTextDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: 100,
          },
        }}
      >
        <DialogTitle>Enter Unique ID Text</DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label=""
            value={copyText}
            onChange={(e) => setCopyText(e.target.value)}
            sx={{ marginTop: 1 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseTextDialog}>Cancel</Button>
          <Button variant="contained" color="success" onClick={handleSubmitCopyText}>
            Copy Link
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteDialog}
        onClose={cancelDeleteSchool}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: '#d32f2f', fontWeight: 'bold' }}>
          Delete School
        </DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to delete the school
            <strong> "{deleteTarget?.name}"</strong>?
          </Typography>

          <Typography sx={{ mt: 1, color: 'gray' }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={cancelDeleteSchool}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={confirmDeleteSchool}
            disabled={deleteLoading}
          >
            {deleteLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>



      <StandardMuiDialogWrapper
        open={openDialog}
        setOpen={setOpenDialog}
        onExited={onExited}
        dialogTitle={`${editActive ? "Update" : "Add"} Schools`}
        onSaveBtnClick={editActive ? onSaveEdit : onAddSchool}
        saveBtnLabel={editActive ? "Update" : "Save"}
        saveBtnLoading={dialogBtnLoading}
      >
        <TextField
          label="School Name"
          variant="outlined"
          name="name"
          value={addSchoolData.name}
          fullWidth
          sx={{ marginTop: 1.5 }}
          onChange={(e) => handleSchoolNameChange(e.target.value)}
        />
        <StandardOutlinedTextfield
          label="School Address"
          name="address"
          val={addSchoolData.address}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <Box sx={{ position: 'relative', marginTop: 1.5 }}>
          <TextField
            label="School Login ID"
            variant="outlined"
            name="school_login_id"
            value={addSchoolData.school_login_id}
            fullWidth
            onChange={(e) => setAddSchoolData({ ...addSchoolData, [e.target.name]: e.target.value })}
            InputProps={{
              endAdornment: !editActive && (
                <InputAdornment position="end">
                  <Tooltip title="Regenerate Login ID">
                    <IconButton
                      onClick={regenerateLoginId}
                      edge="end"
                      size="small"
                      disabled={!addSchoolData.name || addSchoolData.name.trim() === ''}
                    >
                      <Refresh />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <StandardOutlinedTextfield
          label="School Password"
          name="secret_code"
          val={addSchoolData.secret_code}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Contact Person Name"
          name="contact_person"
          val={addSchoolData.contact_person}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Delivery Address"
          name="del_address"
          val={addSchoolData.del_address}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Contact Person Mobile No"
          name="con_mobile"
          val={addSchoolData.con_mobile}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Final Count"
          name="final_count"
          val={addSchoolData.final_count}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <FormControlLabel
          sx={{ mt: 1.5 }}
          control={
            <Switch
              checked={addSchoolData?.is_ids === 1}
              onChange={(e) =>
                setAddSchoolData((prev) => ({
                  ...prev,
                  is_ids: e.target.checked ? 1 : 0,
                }))
              }
              color="primary"
            />
          }
          label="Want to show Teacher QR in APP"
        />

      </StandardMuiDialogWrapper>
    </StandardPageWrapper>
  );
}

export default Schools

const tableColumns = [
  {
    label: 'School ID',
    key: 'schoolid',
    width: 100,
    align: 'center'
  },
  {
    label: 'Name',
    key: 'name',
    width: 250,
    fixed: false,
  },
  {
    label: 'Login ID',
    key: 'school_login_id',
    width: 150,
    fixed: false,
  },

  {
    label: 'Password',
    key: 'school_secret',
    width: 150,
    fixed: false,
  },
  {
    label: 'Pending IDs',
    key: 'pending_count',
    width: 100,
    align: 'center'
  },
  {
    label: 'Verified IDs',
    key: 'verified_count',
    width: 100,
    align: 'center'
  },
  {
    label: 'Verified Downloaded',
    key: 'verified_is_downloaded',
    width: 120,
    align: 'center',
    render: () => 0
  },
  {
    label: 'Verified Not Downloaded',
    key: 'verified_not_downloaded',
    width: 140,
    align: 'center',
    render: () => 0
  },
  {
    label: 'Total Count',
    key: 'final_count',
    width: 100,
    align: 'center'
  },
  {
    label: 'Address',
    key: 'address',
    flexGrow: 1,
    fullText: true,
    minWidth: 200,
  },
  {
    label: 'Contact Person Name',
    key: 'contact_person',
    width: 200,
    fixed: false,
    fullText: true,
  },
  {
    label: 'Delivery Address',
    key: 'del_address',
    width: 150,
    fixed: false,
    fullText: true,
  },
  {
    label: 'Contact Person Mobile No',
    key: 'con_mobile',
    width: 150,
    fixed: false,
    fullText: true,
  }
]
